<script setup>
import { reactive, ref } from "vue";
import BpmnView from "@/components/BpmnView.vue";
import { startProcess, getStartProcessInfo } from "@/api/processInitiation";
import { ElMessage } from "element-plus";
import useSystemList from "../hooks/useSystemList";

// 弹窗控制
const visible = ref(false);

// 系统列表
const { systemList } = useSystemList();

// 过滤后的系统列表
const filterSystemList = ref([]);

// 遮罩
const loading = ref(false);

// 提交按钮遮罩
const buttonLoading = ref(false);

// 表单对象
const ruleRef = ref(null);

const vFormRenderReF = ref(null);

// 当前是哪个系统发起的
const serviceCode = ref(null);

// 流程字符串
const xmlStr = ref("");

// 参数
const dialogConfig = ref({});

// 当前登录用户
const loginUser = ref(null);

// 表单
const formData = reactive({
  id: null,
  title: null,
  startTime: null,
  endTime: null,
  remark: null,
});

const definitionId = ref(null);

const starter = ref(null);

const processName = ref(null);

const formKey = ref(null);

const formConf = ref({
  fields: [],
  formRef: "elForm",
  formModel: "formData",
  size: "medium",
  labelPosition: "right",
  labelWidth: 100,
  formRules: "rules",
  gutter: 15,
  disabled: false,
  span: 24,
  formBtns: false,
});

// 弹窗打开
const handleDialogOpen = (config) => {
  loginUser.value = JSON.parse(localStorage.getItem("userInfo")).name;
  dialogConfig.value = { ...config };
  xmlStr.value = config.processXmlStr;
  definitionId.value = config.definitionId;
  serviceCode.value = null;
  formConf.value = {
    fields: [],
    formRef: "elForm",
    formModel: "formData",
    size: "medium",
    labelPosition: "right",
    labelWidth: 100,
    formRules: "rules",
    gutter: 15,
    disabled: false,
    span: 24,
    formBtns: false,
  };
  viewForm();
  filterList();
  visible.value = true;
};

const filterList = () => {
  systemList.value.map((i) => {
    i.dictValue = i.dictValue.toString();
  });
  filterSystemList.value = systemList.value.filter((item) =>
    dialogConfig.value.serviceCode.split(",").includes(item.dictValue)
  );

  if (filterSystemList.value.length == 1) {
    serviceCode.value = filterSystemList.value[0].dictValue;
  }
};

const viewForm = () => {
  loading.value = true;
  getStartProcessInfo(definitionId.value)
    .then((res) => {
      definitionId.value = res.data.definitionId;
      starter.value = res.data.starter;
      processName.value = res.data.definitionName;
      xmlStr.value = res.data.xmlStr;
      formKey.value = res.data.formKey;
      if (res.data.content) {
        formConf.value = JSON.parse(res.data.content);
      }
    })
    .finally(() => {
      vFormRenderReF.value.setFormJson(formConf.value);
      loading.value = false;
    });
};

// 点击提交
const handleSubmit = () => {
  if (!serviceCode.value) return ElMessage.error("请先选择发起系统");
  let formData = {
    definitionId: definitionId.value,
    formKey: formKey.value,
    submitType: "act_submit_type_001",
    serviceCode: serviceCode.value,
  };
  vFormRenderReF.value
    .getFormData()
    .then((res) => {
      const keys = Object.keys(res);
      keys.forEach((key) => {
        formData[key] = res[key];
      });
    })
    .finally(() => {
      // 发起流程
      startProcess(formData).then((res) => {
        if (res.code === "2000") {
          ElMessage.success("提交成功");
          visible.value = false;
        }
      });
    });
};

// 点击关闭
const handleClose = () => {
  ruleRef.value?.resetFields();
  xmlStr.value = "";
  visible.value = false;
};

defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    title="发起流程"
    v-model="visible"
    :close-on-click-modal="false"
    width="55%"
  >
    <div v-loading="loading">
      <el-row :gutter="10" class="top_title">
        <el-col :span="8">
          <span>提交人： {{ loginUser }}</span>
        </el-col>
        <el-col :span="8">
          <span>流程名称： {{ processName }}</span>
        </el-col>
        <el-col :span="8">
          <span
            >发起系统：<el-select
              v-model="serviceCode"
              placeholder="请选择发起系统"
              filterable
            >
              <el-option
                v-for="item in filterSystemList"
                :key="item.id"
                :label="item.dictLabel"
                :value="item.dictValue"
              /> </el-select
          ></span>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <div class="title">基本信息</div>
          <div>
            <v-form-render
              :form-json="formConf"
              :form-data="formData"
              ref="vFormRenderReF"
            />
          </div>
        </el-col>
      </el-row>

      <el-row id="viewDiv">
        <bpmn-view :xmlStr="xmlStr" />
      </el-row>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose()">关闭</el-button>
        <el-button
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
        >
          提交
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<style scoped>
.top_title {
  margin-bottom: 15px;
}

.title {
  border-left: 5px solid #1a7bb9;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 15px;
}
</style>
